abstract class Button extends Widget {
    protected constructor(identifier: string, controller: Controller, container: JQuery, mode: string) {
        super(identifier, Action.CLICKED, controller, container, mode);
        this.initHTML(container);
        this.initHelpButton();
        this.initAcknowledgements();
        this.initBehavior();
    }

    /**
     * Replace the HTML in this.container with new HTML
     * @param container the old container
     */
    abstract initHTML(container: JQuery);

    /**
     * Add behavior to the newly generated HTML
     * @pre this.container needs to be updated to the new HTML container
     */
    initBehavior() {
        let oThis: Button = this;

        this.container.click(function () {
            if(oThis.isEnabled()) {
                oThis.controller.processEvent(new GUIEvent(oThis.identifier, Action.CLICKED, Effect.EXECUTE, true));
                //oThis.container.trigger('mouseenter'); // Update feedforward
            }
        });

        this.container.hover(function() {
            if(oThis.isEnabled()) {
                oThis.controller.processEvent(new GUIEvent(oThis.identifier, Action.CLICKED, Effect.START_PREVIEW, true));
            }
        }, function () {
            if(oThis.isEnabled()) {
                oThis.controller.processEvent(new GUIEvent(oThis.identifier, Action.CLICKED, Effect.STOP_PREVIEW));
            }
        });
    }

    newState() {
        return new ButtonState();
    }

    setState(buttonState: ButtonState) {
        this.setEnabled(buttonState.enabled);
    }

    getState() {
        let result = new ButtonState();

        result.enabled = this.isEnabled();

        return result;
    }

    previewState(nextState: ButtonState, timeRatioLeft: number) {
        this.previewEnabled(nextState.enabled, timeRatioLeft);
    }

    removePreviewState() {
        this.removePreviewEnabled();
    }
}